import { fetchNetlify } from './netlify'

export const autocompleteAddress = async (address: string) =>
  await fetchNetlify<string[]>(`/.netlify/functions/gcloud-places-autocomplete?address=${address}`)
